import React, { useEffect } from 'react'
import Footer from 'components/Footer'
import Header from 'components/Header'
import NotFoundContent from './components/NotFoundContent'

function NotFound() {
  useEffect(() => {
    document.title = 'Dorac Brasil - Em Construção'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main>
      <Header />
      <NotFoundContent />
      <Footer />
    </main>
  )
}

export default NotFound
